import {type FieldPath, type FieldValues, useController} from "react-hook-form";
import {hofForwardRef, type IonTextareaProps, noop, type RhfProps, type RhfRef} from "app/utils/types";
import {IonTextarea} from "@ionic/react";
import {type ForwardedRef, type RefCallback, useImperativeHandle, useRef} from "react";
import {assignRef} from "app/utils/stdlib";

const extraClassNames = "ion-invalid ion-touched";

const reportValidity = () => true;

export const RhfIonTextarea = hofForwardRef(
  <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
    {rhf, disabled, className, ...rest}: IonTextareaProps & RhfProps<TFieldValues, TName>,
    ref: ForwardedRef<HTMLIonTextareaElement>
  ) => {
    const {
      field: {ref: fieldRef, onChange, disabled: rhfDisabled, ...restField},
      fieldState: {error},
      formState: {isSubmitting}
    } = useController(rhf);

    const classNames = [];
    if (className) {
      classNames.push(className);
    }

    if (error) {
      classNames.push(extraClassNames);
    }

    const rhfRef = useRef<RhfRef | null>(null);
    const inputRef: RefCallback<HTMLIonTextareaElement> = (element) => {
      assignRef(ref, element);

      rhfRef.current = {
        focus: () => element?.setFocus(),
        select: () => element?.getInputElement?.()?.then((e) => e?.select()),
        setCustomValidity: noop,
        reportValidity
      };
    };
    useImperativeHandle(fieldRef, () => rhfRef.current);

    return (
      <IonTextarea
        ref={inputRef}
        {...rest}
        {...restField}
        className={classNames.join(" ")}
        disabled={isSubmitting || disabled || rhfDisabled}
        errorText={error?.message}
        onIonInput={(event) => onChange(event.detail.value)}
      />
    );
  }
);
